function isValidDate(d) {
  if (Object.prototype.toString.call(d) === '[object Date]') {
    // it is a date
    return !Number.isNaN(d.getTime());
  }
  return false; // not a date
}

function dateDiff(date1, date2) {
  if (isValidDate(date1)) {
    if (isValidDate(date2)) {
      const diff = {}; // Initialisation du retour
      let tmp = date2 - date1;

      tmp = Math.floor(tmp / 1000); // Nombre de secondes entre les 2 dates
      diff.sec = tmp % 60; // Extraction du nombre de secondes

      tmp = Math.floor((tmp - diff.sec) / 60); // Nombre de minutes (partie entière)
      diff.min = tmp % 60; // Extraction du nombre de minutes

      tmp = Math.floor((tmp - diff.min) / 60); // Nombre d'heures (entières)
      diff.hour = tmp % 24; // Extraction du nombre d'heures

      tmp = Math.floor((tmp - diff.hour) / 24); // Nombre de jours restants
      diff.day = tmp;

      return diff;
    }
    throw new Error(`Not a JS date2: ${date2}`);
  }
  throw new Error(`Not a JS date1: ${date1}`);
}

function inputStringToUTCDate(dateString) {
  const date = new Date(dateString);
  if (dateString && isValidDate(date)) {
    return date;
  }
  throw new Error(`Not a valid date string: ${dateString}`);
}

function formatDateToInput(date) {
  if (isValidDate(date)) {
    const tzoffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
    return new Date(date - tzoffset).toISOString();
  }
  throw new Error(`Not a JS date: ${date}`);
}

/**
 * @returns {string|null} The date formated for date input value
 * @param date
 */
function formatDateToInputDate(date) {
  if (isValidDate(date)) {
    return formatDateToInput(date).split('T')[0];
  }
  return null;
}

/**
 * @returns {string|null} The date formated for datetime input value
 * @param date
 */
function formatDateToInputDateTime(date) {
  if (isValidDate(date)) {
    return formatDateToInput(date).slice(0, 19);
  }
  if (isValidDate(new Date(date))) {
    return formatDateToInput(new Date(date)).slice(0, 19);
  }
  return null;
}

/**
 * @returns {string|null} The date formated for insert in ORACLE database
 * @param date
 */
function formatInputDateTimeToGMTDate(date) {
  if (date && isValidDate(new Date(date))) {
    return new Date(date)
      .toISOString()
      .slice(0, 19)
      .replace('T', ' ');
  }
  return null;
}

/**
 * @returns {string} The current date
 */
function getCurrentLocalDate() {
  return formatDateToInputDate(new Date(Date.now()));
}

function getCurrentLocalDateTime() {
  return formatDateToInput(new Date(Date.now())).slice(0, 19);
}

function formatGMTDateToJavascriptDate(date) {
  if (date && isValidDate(new Date(date))) {
    return new Date(date);
  }
  return null;
}

function getLastDayInputDateTime() {
  const now = new Date(Date.now());
  return formatDateToInputDateTime(new Date(now.setDate(now.getDate() - 1)));
}
function getThisDayInputDateTime() {
  const now = new Date(Date.now());
  return formatDateToInputDateTime(new Date(now.setHours(0, 0, 0, 0)));
}

export {
  formatDateToInputDateTime,
  getLastDayInputDateTime,
  getThisDayInputDateTime,
  formatInputDateTimeToGMTDate,
  dateDiff,
  isValidDate,
  inputStringToUTCDate,
  formatDateToInput,
  formatDateToInputDate,
  getCurrentLocalDate,
  getCurrentLocalDateTime,
  formatGMTDateToJavascriptDate,
};
